import {
  APP_BASE_HREF,
  HashLocationStrategy,
  LocationStrategy,
  PathLocationStrategy,
  PlatformLocation,
} from '@angular/common';
import { Provider } from '@angular/core';

import { APP_ORIGIN } from './app-origin.provider';

const initializeLocationStrategy = (
  platformLocation: PlatformLocation,
  origin: string,
  baseHref: string,
) => {
  return window.origin === origin
    ? new PathLocationStrategy(platformLocation, baseHref)
    : new HashLocationStrategy(platformLocation, baseHref);
};

export function provideLocationStrategy() {
  const providers: Provider[] = [
    {
      provide: LocationStrategy,
      useFactory: initializeLocationStrategy,
      deps: [PlatformLocation, APP_ORIGIN, APP_BASE_HREF],
    },
  ];

  return providers;
}
